module.exports = __webpack_public_path__ + "static/img/index_mod4bg.a4aaadc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_mod4bg.png
// module id = sKoV
// module chunks = 1